// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-f5-attribute] {
    font-size: 0.9em;
}
[data-f5-attribute="git_u"] {
    &::after {
        content: 'U';
    }
}
[data-f5-attribute="git_m"] {
    &::after {
        content: 'M';
    }
}
[data-f5-attribute="git_a"] {
    &::after {
        content: 'A';
    }
}
.d [data-f5-attribute="git_c"] {
    font-size: .5em;
    &::after {
        content: '⬤';
    }
}

[data-f5-attributes~="git_u"] * {
    --color: #6DA862;
    --selected-color: #6DA862;
}
[data-f5-attributes~="git_m"] * {
    --color: #BD923D;
    --selected-color: #BD923D;
}
[data-f5-attributes~="git_a"] * {
    --color: #6DA862;
    --selected-color: #6DA862;
}

.d[data-f5-attributes~="git_c"] * {
    --color: #6DA862;
    --selected-color: #6DA862;
}


[data-f5-attributes~="git_i"] * {
    --color: #656E7A;
    --selected-color: #656E7A;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
